import React from 'react';
import { usePrivacyPolicyPageFieldsQuery } from './api/privacyPolicyApi';
import styles from './styles/PrivacyPolicyPage.module.scss'
import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { showLoader, hideLoader } from '../GlobalLoader/globalLoaderSlice';
import AnimatedBanner from '../../components/AnimatedBanner/AnimatedBanner';
import StaticBanner from '../../components/StaticBanner/StaticBanner'

function PrivacyPolicyPage() {
    const { data, error, isError, isLoading } = usePrivacyPolicyPageFieldsQuery();
    const dispatch = useDispatch();
    const loaderId = { id: 'privacy_policy' };

    useEffect(() => {
        if (isLoading) {
            dispatch(showLoader(loaderId));
        } else {
            dispatch(hideLoader(loaderId));
        }
    }, [isLoading, dispatch]);


    return (
        <div className={styles.policyPage}>
            {
                data?.banner_type === 'animated_banner' ?
                    <AnimatedBanner
                        title={data?.title}
                        subtitle={data?.subtitle}
                        height='40vh'
                        scrollTo={false}
                    />
                    :
                    <StaticBanner
                        title={data?.title}
                        background={data?.backgroundImage}
                        page={'privacyAndTerms'}
                    />
            }
            <div className="container">
                <div className={styles.privacyPolicyWrapper}>
                    <div dangerouslySetInnerHTML={{ __html: data?.content }} />
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicyPage;
